import useGetNewsTipsToPreview from './useGetNewsTipsToPreview'
export default useGetNewsTipsToPreview
